<section class="card-container max_width_page_component">
  <div class="card-header">
    <div class="card-header-inner">
      @if (!dataIsLoading()) {
        <h2>{{ title() }}</h2>
        @if (!shouldDisplayPriceComp()) {
          <p class="hub-section-description">{{ description() }}</p>
        }
      } @else {
        <app-header-loader />
      }
    </div>
  </div>
  <div class="article_container">
    <div
      #scrollContainer
      class="draggable-scroll"
      #scrollable
      (scroll)="updateScrollButtons()"
      (mousedown)="onMouseDown($event)"
      (mousemove)="onMouseMove($event)"
      (mouseup)="onMouseUp()"
      (mouseleave)="onMouseLeave()"
      [ngClass]="{
        displayMode: displayMode() === 'rows' || displayMode() === 'cols',
        gridStyle1: displayMode() === 'grid1',
        gridStyle2: displayMode() === 'grid2',
        gridStyle3: displayMode() === 'grid3',
        gridStyle4: displayMode() === 'grid4',
        'full-width': displayMode() === 'full-width',
      }"
    >
      @if (dataIsLoading()) {
        @for (
          placeholder of isVerticalCard() ? [1] : [1, 2];
          track placeholder
        ) {
          <app-card-loader [isVerticalCard]="isVerticalCard()" />
        }
      }

      @if (!dataIsLoading() && (!entityData() || entityData().length === 0)) {
        <div class="no-data-placeholder"></div>
      }

      @if (!dataIsLoading() && entityData() && entityData().length > 0) {
        @for (
          entity of entityData();
          track getTrackById(entity);
          let index = $index
        ) {
          <a
            [href]="generateUrl(entity)"
            [ngClass]="{
              'full-width-link': $safeNavigationMigration(entity?.uniqueId),
              link: isDisabled(),
            }"
          >
            <article
              [style.border-radius]="borderRadius()"
              [ngClass]="{
                price_comp_card: shouldDisplayPriceComp() && index === 0,
                isVerticalCard: isVerticalCard(),
              }"
              class="card"
            >
              @if (index === 0) {
                @if (
                  entity && isPriceGuide(entity) && shouldDisplayPriceComp()
                ) {
                  <app-price-average
                    [isHubPage]="true"
                    [priceLow]="Number(entity.price_guide?.min || 0)"
                    [priceMedium]="Number(entity.price_guide?.middle || 0)"
                    [priceHigh]="Number(entity.price_guide?.max || 0)"
                    [title]="
                      'COMPONENTS.CUSTOM_CARD.READ_PRICE_GUIDE' | translate
                    "
                  />
                } @else if (shouldDisplayReviewComp()) {
                  <div class="review_container">
                    <app-review-overview
                      [reviewCount]="reviewCount()"
                      [verticalName]="categoryOrVerticalName()"
                    />
                  </div>
                }
              }
              @if (!(shouldDisplayPriceComp() && index === 0)) {
                <div
                  [ngClass]="{ custom_img_container: isVerticalCard() }"
                  class="img-container"
                >
                  @if (entity.imgUrl || entity.image) {
                    <img
                      class="card-img"
                      [ngSrc]="entity.imgUrl || entity.image"
                      alt="image"
                      fill
                    />
                  } @else {
                    <img
                      class="card-img"
                      [ngSrc]="defaultImage"
                      alt="image"
                      width="350"
                      height="150"
                    />
                  }
                </div>
              }

              <div
                class="card-body"
                [ngClass]="{
                  is_main_price_desc: shouldDisplayPriceComp() && index === 0,
                }"
              >
                @if (entity.publish_date || entity.date) {
                  <div class="date">
                    @if (!isVerticalCard()) {
                      <p>
                        {{
                          getDate(entity.publish_date || entity.date)
                            | date: 'EEEE d. MMM yyyy'
                        }}
                      </p>
                      <p>
                        {{ 'PAGES.HUB.READING_TIME' | translate }}
                        {{
                          entity?.readingTimeStats?.minutes
                            ? entity.readingTimeStats.minutes.toFixed(0)
                            : '0'
                        }}
                        min.
                      </p>
                    }
                  </div>
                } @else {
                  <div class="date custom_card">
                    <p>{{ todayDate | date }}</p>
                    <p>{{ 'PAGES.HUB.READING_TIME' | translate }} 3 min.</p>
                  </div>
                }
                <h3>{{ entity?.title || entity?.int }}</h3>

                @if (entity?.price_guide) {
                  <p class="guide-description">{{ entity?.answer }}</p>

                  <div class="guide-meta">
                    @if (entity.price_guide) {
                      <div class="price-range">
                        <mat-icon>payments</mat-icon>
                        <span>{{
                          entity.price_guide.min
                            | formatCurrencyRange: entity.price_guide.max
                        }}</span>
                      </div>
                    }
                  </div>
                } @else {
                  <p class="desc">
                    {{
                      entity?.description ||
                        entity?.content?.sub_header ||
                        entity?.meta_description ||
                        entity?.mT
                    }}
                  </p>
                }
              </div>
            </article>
          </a>
        }
        @if (isAiPriceGuide()) {
          <a
            [href]="aiPriceGuideIndexLink()"
            [ngClass]="{
              'full-width-link': displayMode() === 'full-width',
              link: isDisabled(),
            }"
          >
            <article
              [style.border-radius]="borderRadius()"
              class="card"
              style="border-radius: 20px"
            >
              <div class="card-body" [ngClass]="'/' + { tips_card_body: true }">
                <h3 [ngClass]="{ tips_header: true }">
                  {{ 'COMPONENTS.CUSTOM_CARD.SEE_ALL_PRICE_DATA' | translate }}
                </h3>
              </div>
            </article>
          </a>
        }
      }
    </div>

    @if (!isVerticalCard() && entityData() && entityData().length > 0) {
      @if (showLeft()) {
        <button
          class="scroll_button left"
          [ngClass]="{
            dont_show_scroll: $safeNavigationMigration(
              entityData()[0]?.uniqueId
            ),
          }"
          (click)="scrollLeft()"
        >
          <mat-icon>keyboard_arrow_left</mat-icon>
        </button>
      }

      @if (showRight()) {
        <button
          class="scroll_button right"
          [ngClass]="{
            dont_show_scroll: $safeNavigationMigration(
              entityData()[0]?.uniqueId
            ),
          }"
          (click)="scrollRight()"
        >
          <mat-icon>keyboard_arrow_right</mat-icon>
        </button>
      }
    }
  </div>
</section>
